export default __webpack_public_path__ + "static/media/gif.bca25cf3.png";